// import api from "@/plugins/api";

// export const action1 = async ({ commit }, body) => {
//   const response = await api({
//     method: "GET",
//     endpoint: "myclients",
//     body: body
//   });

//   const { data } = response;

//   commit("mutation1", data);
// };

export const resetPagination = ({ commit }) => {
  commit("resetPagination");
};
